import React from 'react';

import { Tag as RKSTag } from '@uncinc/uncinc-react-kitchen-sink';
import { TagProps as RKSTagProps } from '@uncinc/uncinc-react-kitchen-sink/dist/components/Tag';

import './style.scss';

export interface TagProps extends Omit<RKSTagProps, 'className'> {
  type: 'theme' | 'article-type';
}

const Tag: React.FC<TagProps> = (props) => {
  const {
    type,
    name,
    ...restProps
  } = props;

  return (
    <RKSTag
      {...restProps}
      className={`Tag--${type}`}
      name={name}
    />
  );
};

export default Tag;
